module.exports = __webpack_public_path__ + "img/example6.61ac90fc.jpg";